import { render, staticRenderFns } from "./ListEventosHome.vue?vue&type=template&id=2c4b1682&"
import script from "./ListEventosHome.vue?vue&type=script&lang=js&"
export * from "./ListEventosHome.vue?vue&type=script&lang=js&"
import style0 from "./ListEventosHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports